function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.33333 0 0 -1.33333 -256.53 642.069)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(192.397 461.168)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e9038b",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0l35.32 20.383L23.531 0z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(192.397 461.168)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fbe719",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0h23.531l35.311-61.153L94.145 0l11.77-20.384-47.076-81.533z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(215.928 461.168)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1cb0ed",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0l11.79 20.383 35.289-61.151-11.767-20.385z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(286.542 461.168)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e9038b",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0h23.54L11.77-20.384z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(310.082 461.168)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fbe719",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0l-11.771-20.384 23.539-40.769 11.769 20.386z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(251.236 359.252)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#e44e3a",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0h23.541l23.534 40.764v40.769z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(298.312 440.785)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#19b2c7",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0l23.538-40.769L70.61 40.765l11.768-20.381L23.546-81.533 0-40.769z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(380.69 461.168)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#142c34",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0l-58.832-101.917 23.527-.003L23.539 0z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(368.922 481.55)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#142c34",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0l35.307-20.381H11.768z"
})));

var SvgWemanity = function SvgWemanity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282.443,
    height: 163.071,
    viewBox: "0 0 282.443 163.071",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWemanity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wemanity.d672bfb2.svg";
export { ForwardRef as ReactComponent };